"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Image = _interopRequireDefault(require("ol/layer/Image"));

var _Raster = _interopRequireDefault(require("ol/source/Raster"));

var _XYZ = _interopRequireDefault(require("ol/source/XYZ"));

var _createLayer = _interopRequireDefault(require("./createLayer"));

var _propTypes = require("prop-types");

var RasterLayer = (0, _createLayer["default"])({
  displayName: 'RasterLayer',
  propTypes: {
    afterOperations: _propTypes.func,
    beforeOperations: _propTypes.func,
    operation: _propTypes.func.isRequired,
    sources: _propTypes.array.isRequired // TODO: add operationType: http://openlayers.org/en/latest/apidoc/ol.source.html#.RasterOperationType
    // TODO: add threads: http://openlayers.org/en/latest/apidoc/ol.source.Raster.html

  },
  componentDidMount: function componentDidMount() {
    this.layer = new _Image["default"]({
      source: this.createRasterSource(this.props)
    });
  },
  componentDidUpdate: function componentDidUpdate(prevProps) {
    if (this.props.operation !== prevProps.operation) {
      this.layer.getSource().setOperation(this.props.operation);
    }
  },
  createRasterSource: function createRasterSource(props) {
    var raster = new _Raster["default"]({
      sources: this.createChildSources(props.sources),
      operation: props.operation
    });

    if (this.props.beforeOperations) {
      raster.on('beforeoperations', this.props.beforeOperations);
    }

    if (this.props.afterOperations) {
      raster.on('afteroperations', this.props.afterOperations);
    }

    return raster;
  },
  createChildSources: function createChildSources(array) {
    return array.map(function (item) {
      var source;

      if (typeof item === 'string' || Array.isArray(item)) {
        source = new _XYZ["default"]({
          url: item,
          crossOrigin: 'anonymous'
        });
      } else {
        source = item;
      }

      return source;
    });
  }
});
var _default = RasterLayer;
exports["default"] = _default;